import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { DriverLabel } from "../../../hooks/useDriverLabels";
import { AuditRow } from "../../../models/AuditRow";
import { EmptyValue } from "../../common/EmptyValue";
import { rowDriverIds } from "../rowValues";

interface Props extends GridRenderCellParams<AuditRow> {
  driverLabel: DriverLabel;
}

/** The entry's driver, or every driver of the day; name or user id depending on the viewer's role. */
export function DriverCell({ row, driverLabel }: Props) {
  const ids = rowDriverIds(row);
  if (ids.length === 0) return <EmptyValue />;
  const text = ids.map(driverLabel).join(", ");
  return (
    <Tooltip title={text}>
      <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {text}
      </Box>
    </Tooltip>
  );
}
